const CLEAR_AUTHENTICATION = 'CLEAR_AUTHENTICATION';
const SAVE_AUTHENTICATION = 'SAVE_AUTHENTICATION';

export {
  CLEAR_AUTHENTICATION,
  SAVE_AUTHENTICATION,
};
